export const formatMoney = (money) => {
    if (!money) return 'R$ 0,00'
    const real = new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
    })
    return real.format(money)
}